// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"18":"944a72f2","50":"f6149187","93":"e0a412c8","633":"2494e48b","881":"ad3bd66a","965":"61032cc2"}[chunkId] + ".js";
};